/**
 * /web-design page bundle — migrated from public/js/web-design.js.
 *
 * 4 sectiuni:
 *   1. Focus / blur pe inputs cu .lb-focused (parinte .input-line)
 *   2. .offer-card close icon — remove parinte
 *   3. .request-form — Resort.Form() pentru validation, submit ramane nativ
 *      (form are method=post + action="/message/send", Form() devine no-op via shim)
 */

import { Resort } from '../core/resort.js';

new Resort(() => {
    /* Inputs focus/blur — aura pe parinte .input-line */

    $('input[type="text"], textarea', true).on('focus', function (this: Element) {
        const p = this.parents('.input-line') as HTMLElement | null;
        if (p && !p.classList.contains('lb-focused')) p.classList.add('lb-focused');
    });

    $('input[type="text"], textarea', true).on('blur', function (this: Element) {
        const p = this.parents('.input-line') as HTMLElement | null;
        if (p?.classList.contains('lb-focused')) p.classList.remove('lb-focused');
    });

    /* Offer card close */

    ($('.offer-card') as Element | null)?.on('click', '.ic-close', function (this: Element) {
        (this.parents('.offer-card') as HTMLElement | null)?.remove();
    });

    /* Request form — pattern identic cu legacy. Form() devine no-op pentru
     * form cu method=post + action (vezi form/form.ts shim integrat). */

    const requestForm = $('.request-form') as HTMLFormElement | null;
    if (requestForm) {
        requestForm.Form('form', 'webdesign_send_request', {}, {
            valid: () => ({
                name:   'nn()',
                email:  'mail()',
                phone:  'min(10)',
                accept: 'nn()',
            }),
            done: () => { /* no-op — submit nativ catre /message/send */ },
        });
    }
});
